import { render, staticRenderFns } from "./SchoolYearInput.vue?vue&type=template&id=703ffa04"
import script from "./SchoolYearInput.vue?vue&type=script&lang=js"
export * from "./SchoolYearInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports